import constants from "../../core/constants";
import map from "lodash/fp/map";
import assign from "lodash/fp/assign";
class PricingsPageTransform {
  constructor() {
    "ngInject";
    this.item = { state: "pricing" };
    this.fields = [
      { title: "From", name: "from_city" },
      { title: "To", name: "to_city" },
      { title: "Bus Type", name: "bus_type" },
    ];
    this.addOptions = {
      title: "Add New Pricing",
      icon: "add",
      fields: [
        {
          resource: "City",
          name: "from_city",
          title: "From",
          isResource: true,
          isRequired: true,
        },
        {
          resource: "City",
          name: "to_city",
          title: "To",
          isResource: true,
          isRequired: true,
        },
        {
          resource: "Bustype",
          name: "bus_type",
          title: "Bustype",
          isResource: true,
          isRequired: true,
        },
        {
          name: "one_way_pricing",
          title: "One Way Pricing",
          type: "number",
          isText: true,
          isRequired: false,
          formatter: (item) => item * constants.currencyBy,
        },
        {
          name: "on_same_day_pricing",
          title: "On Same Day Pricing",
          type: "number",
          isText: true,
          isRequired: false,
          formatter: (item) => item * constants.currencyBy,
        },
        {
          name: "on_another_day_pricing",
          title: "On Another Day Return Pricing",
          type: "number",
          isText: true,
          isRequired: false,
          formatter: (item) => item * constants.currencyBy,
        },
        {
          name: "is_one_way_allowed",
          title: "Allow One Way Trip",
          isCheckBox: true,
          isRequired: true,
        },
        {
          name: "is_on_another_day_allowed",
          title: "Alow Another Day Return",
          isCheckBox: true,
          isRequired: true,
        },
        {
          name: "is_on_same_day_allowed",
          title: "Allow on Same Day Return",
          isCheckBox: true,
          isRequired: true,
        },
        {
          name: "one_day_span",
          title: "One Day Time Span  (Hours)",
          type: "number",
          isText: true,
          isRequired: true,
          formatter: (item) => item * constants.fromHourToMilli,
        },
      ],
    };
  }

  justify(data) {
    const getSource = (item) => assign({ _id: item._id }, item._source);
    return map(getSource)(data);
  }
}

export default PricingsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/pricings/pricings.transforms.js